// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-orders/edit-orders.less
// module id = 3810
// module chunks = 0